import { FC, Fragment, useEffect, useState } from 'react';
import { PackageFilterModel } from 'ts/package/classes/PackageFilterModel';
import { Range } from 'react-range';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface PackageResultFilterSliderProps {
  filter: PackageFilterModel;
  onChangeFilter: (filter: PackageFilterModel) => void;
  minStr: string;
  maxStr: string;
  type: 'price';
}

const PackageResultFilterSlider: FC<PackageResultFilterSliderProps> = ({
  filter,
  onChangeFilter,
  type,
  ...props
}) => {
  const [values, setValues] = useState(filter[type]?.value);
  const colorContrast = getComputedStyle(document.body).getPropertyValue('--color-contrast');

  useEffect(() => {
    setValues(filter[type]?.value);
  }, [filter[type]?.value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      {filter[type]?.min !== filter[type]?.max && (
        <Fragment>
          <div className="flight-filter-time text-lh-sm text-xsm">
            <span>{props.minStr}</span>
            <span>{props.maxStr}</span>
          </div>
          <Range
            step={1}
            rtl={localStorage.getItem('language') === 'he'}
            min={filter[type]?.min}
            max={filter[type]?.max}
            onFinalChange={() =>
              onChangeFilter({ ...filter, [type]: { ...filter[type], value: values } })
            }
            values={values!}
            onChange={(values) => setValues(values as [number, number])}
            renderTrack={({ props, children }) => (
              <div
                {...props}
                style={{
                  ...props,
                  height: '4px',
                  width: 'calc(100% - 16px)',
                  margin: '0 8px',
                  backgroundColor: '#ccc',
                }}
              >
                {children}
              </div>
            )}
            renderThumb={({ props }) => (
              <div
                {...props}
                style={{
                  ...props,
                  position: 'absolute',
                  height: '16px',
                  width: '16px',
                  borderRadius: '50%',
                  backgroundColor: colorContrast,
                }}
              />
            )}
          />
          <div className="mb-20"></div>
        </Fragment>
      )}
    </div>
  );
};

export default withErrorBoundary(PackageResultFilterSlider, 'PackageResultFilterSlider');
